import global from "./global.json";

export const pl = {
  global,
};
